import { useState } from "react";

export function useSelectedUserId() {
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);

  const selectUserId = (id: string) => {
    setSelectedUserId(id);
  };

  const clearUserId = () => {
    setSelectedUserId(null);
  };

  return {
    selectedUserId,
    selectUserId,
    clearUserId,
  };
}
